import { CreditReportLandingComponent } from './credit-report-landing.component';

export const containers: any[] = [CreditReportLandingComponent];

export * from './credit-report-landing.component';
